import { useState } from "react";
import { resolveConnectorIcon, monogramInitials, DEFAULT_CONNECTOR_COLOR } from "./connector-icon";

// Shared connector icon used by both IntegrationHub render sites (catalog grid
// + connected list). Renders a self-hosted SVG logo when `icon` is a URL (on a
// neutral white tile so multi-color logos read cleanly), else a monogram tile
// tinted with the provider color. Never renders an emoji. If the logo 404s,
// onError falls back to the same monogram.
export function ConnectorIcon({
  icon,
  name,
  color,
  className = "",
}: {
  icon?: string | null;
  name: string;
  color?: string | null;
  className?: string;
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const resolved = resolveConnectorIcon({ icon, name });
  const tint = color || DEFAULT_CONNECTOR_COLOR;
  const base = `w-12 h-12 rounded-xl flex items-center justify-center shrink-0 overflow-hidden ${className}`;

  if (resolved.mode === "img" && !imgFailed) {
    return (
      <div className={`${base} bg-white`}>
        <img
          src={resolved.src}
          alt={name}
          className="w-full h-full object-contain p-1.5"
          onError={() => setImgFailed(true)}
        />
      </div>
    );
  }

  return (
    <div className={`${base} font-semibold text-base`} style={{ backgroundColor: `${tint}15`, color: tint }}>
      {monogramInitials(name)}
    </div>
  );
}
